<script setup></script>

<template>
    <div
        class="mx-auto flex w-full max-w-screen-sm items-center justify-center p-6 text-center text-xl font-extrabold uppercase"
    >
        <slot />
    </div>
</template>
